export default __webpack_public_path__ + "static/media/female_bone-01.bb510bf4.png";